import { render, staticRenderFns } from "./UserEngagementRow.vue?vue&type=template&id=80eaf1a0&"
import script from "./UserEngagementRow.vue?vue&type=script&lang=js&"
export * from "./UserEngagementRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports